var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notification-bing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.541,14.012l-1.318-2.193a4.615,4.615,0,0,1-.548-1.96V7.677a7.671,7.671,0,1,0-15.342,0v2.17a4.775,4.775,0,0,1-.537,1.96L.478,14a3.1,3.1,0,0,0-.3,2.66,3.069,3.069,0,0,0,1.96,1.832,25.811,25.811,0,0,0,3.827.945c.128.023.257.035.385.058.163.023.338.047.513.07.3.047.607.082.922.1.735.07,1.482.1,2.228.1s1.47-.035,2.193-.1c.268-.023.537-.047.793-.082.21-.023.42-.047.63-.082.128-.012.257-.035.385-.058a24.573,24.573,0,0,0,3.862-.957,3.091,3.091,0,0,0,1.913-1.843A3.044,3.044,0,0,0,19.541,14.012Z",
    transform: "translate(4.014 2.392)",
    fill: "#222227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.592.012a3.517,3.517,0,0,1-3.3,2.322A3.459,3.459,0,0,1,.817,1.3,3.221,3.221,0,0,1,0,0C.152.023.3.035.467.058c.268.035.548.07.828.093C1.96.21,2.637.245,3.313.245S4.643.21,5.3.152c.245-.023.49-.035.723-.07Z",
    transform: "translate(10.71 23.333)",
    fill: "#222227"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.c897e34b8846557639d4db6fdd89531f.svg";
export { ForwardRef as ReactComponent };